<script>

import ForgotDefault from "@/views/auth/default/forgot.vue";
import ForgotCcnsw from "@/views/auth/ccnsw/forgot.vue";
import ForgotStw from "@/views/auth/statewide/forgot.vue";
import {mapGetters} from "vuex";

export default {
  components: {ForgotCcnsw, ForgotDefault, ForgotStw},
  data () {
    return {
      host: '',
    }
  },
  methods: {},
  mounted () {
    this.host = window.location.hostname
  },
  computed: {
    ...mapGetters({
      isStatewide: 'isStatewide'
    }),
    isCCNSW () {
      return (this.host == 'ccnsw.partssearch.com.au')
    },
  }
}
</script>

<template>
  <forgot-ccnsw v-if="isCCNSW"></forgot-ccnsw>
  <forgot-stw v-else-if="isStatewide"></forgot-stw>
  <forgot-default v-else></forgot-default>
</template>
